module.exports = __webpack_public_path__ + "img/Logo_TecNM_Vertical_Blanco.6940f373.svg";